import { z } from "zod"

import type { MdxModule } from "@/mdx"

export const legalModules = import.meta.glob<MdxModule>("./legal/*.mdx", {
  eager: true,
})

export const legalDocumentFrontmatterSchema = z.object({
  title: z.string(),
  /** Meta description, 120-155 characters (scripts/check-marketing-pages.mjs). */
  description: z.string().optional(),
  date: z.iso.date(),
  dateModified: z.iso.date().optional(),
})
